
// test
const BASE_URL = "https://joatech.hordecall.net/api/";
// live https://api.joatechglobal.com/
// const BASE_URL = "https://api.joatechglobal.com/api/";


const API_URLS = {
  //============================ admin management =============================
  adminLogin: `${BASE_URL}auth/admin/login`,
  verifyOtp: `${BASE_URL}auth/admin/verify-otp`,
  forgetPassword: `${BASE_URL}auth/admin/forgot-password`,
  resetPassword: `${BASE_URL}admin/reset-password`,
  updatePassword: `${BASE_URL}admin/change-password`,
  addAdmin: `${BASE_URL}admin/create`,
  updateAdminTwoFa: `${BASE_URL}admin/update-two-factor`,
  adminNotifcationStatus: `${BASE_URL}admin/update-notification`,
  getAdmin: `${BASE_URL}admin`,
  UpdateAdmin: `${BASE_URL}admin/update`,
  getAdminById: `${BASE_URL}admin/show`,
  getAdminActivityLog: `${BASE_URL}admin/all-activities`,

  // =============== get permissions =============================
  getPermissions: `${BASE_URL}admin/permissions`,
  updatePermissions: `${BASE_URL}admin/permissions/update`,
  assignPermissions: `${BASE_URL}admin/permissions/assign`,
  getAdminPermissionsByid: `${BASE_URL}admin/permissions/view`,
  removePermissionsFromAdmin: `${BASE_URL}admin/permissions/revoke`,

  // ====================== end of permissions =================
  // =============== get roles =============================
  getRoles: `${BASE_URL}admin/roles`,
  createRole: `${BASE_URL}admin/roles/create`,
  UpdateRole: `${BASE_URL}admin/roles/update`,
  grantPermissionToRole: `${BASE_URL}admin/roles/permissions`,
  assignPermissionToRole: `${BASE_URL}admin/roles/assign`,
  getRolesPermission: `${BASE_URL}admin/roles/show`,
  deleteRoles: `${BASE_URL}admin/roles/delete`,
  // ====================== end of roles =================
  // =========================== categories ====================================-
  getCategory: `${BASE_URL}admin/categories`,
  updateCategory: `${BASE_URL}admin/categories/update`,
  addCategory: `${BASE_URL}admin/categories/create`,
  removeCategory: `${BASE_URL}admin/categories/delete`,

  // =========================== sub categories ===============================
  getSubCategoryById: `${BASE_URL}admin/sub-category`,
  updateSubCategory: `${BASE_URL}admin/sub-category/update`,
  addSubCategory: `${BASE_URL}admin/sub-category/create`,
  removeSubCategory: `${BASE_URL}admin/sub-category/delete`,
  // =========================== products ====================================-
  getProducts: `${BASE_URL}admin/products`,
  getProductsById: `${BASE_URL}admin/products/show`,
  addProducts: `${BASE_URL}admin/products/create`,
  updateProducts: `${BASE_URL}admin/products/update`,
  removeProducts: `${BASE_URL}admin/products/delete`,
  addProductsImages: `${BASE_URL}admin/products/image/add`,
  removeProductsImages: `${BASE_URL}admin/products/image/delete`,
  activateDeactivate: `${BASE_URL}admin/transactions/enable-control`,
  // =========================== products category ====================================-
  getProductsBySubCategoryId: `${BASE_URL}admin/product-category`,
  createProductCategory: `${BASE_URL}admin/product-category/create`,
  updateProductCategory: `${BASE_URL}admin/product-category/update`,
  removeProductsCategory: `${BASE_URL}admin/product-category/delete`,
  // =========================== products stock ====================================-
  getAllProductsStock: `${BASE_URL}admin/product/stocks`,
  getProductsStockById: `${BASE_URL}admin/product/stocks/show`,
  createProductStock: `${BASE_URL}admin/product/stocks/create`,
  updateProductStock: `${BASE_URL}admin/product/stocks/update`,
  removeProductStock: `${BASE_URL}admin/product/stocks/delete`,
  addImagesToProductStock: `${BASE_URL}admin/product/stocks/image/add`,
  removeImagesProductStock: `${BASE_URL}admin/product/stocks/image/delete`,
  addProductStockSupply: `${BASE_URL}admin/product/stocks/supply`,
  addProductStockVariant: `${BASE_URL}admin/product/stocks/variant/create`,
  updateProductStockVariant: `${BASE_URL}admin/product/stocks/variant/update`,
  removeProductStockVariant: `${BASE_URL}admin/product/stocks/variant/delete`,
  addProductStockVariantImages: `${BASE_URL}admin/product/stocks/image/variant/add`,
  // newly added april 2025
  updateProductStockVariantProfit: `${BASE_URL}admin/product/stocks/variant/profit`,
  approveProductStockVariantProfit: `${BASE_URL}admin/product/stocks/variant/approve`,

  //================================= store ========================================
  getAllStore: `${BASE_URL}admin/stores`,
  createStore: `${BASE_URL}admin/stores/create`,
  getAllStoreById: `${BASE_URL}admin/stores/show`,
  updateStore: `${BASE_URL}admin/stores/update`,
  removeStore: `${BASE_URL}admin/stores/delete`,

  // // =========================== customer ====================================-
  getCustomers: `${BASE_URL}admin/customers`,
  getCustomersDetails: `${BASE_URL}admin/customers/show`,
  getWalletTransactions: `${BASE_URL}admin/customers/wallet/transactions`,
  getPhysicalProducts: `${BASE_URL}admin/customers/physical-products`,
  getOtherBills: `${BASE_URL}admin/customers/bill-products`,
  getBalance: `${BASE_URL}admin/customers/balance`,
  getCustomerStatus: `${BASE_URL}admin/customers/update`,

  // =========================== vendor ====================================-
  getAllVendor: `${BASE_URL}admin/vendors`,
  getVendorById: `${BASE_URL}admin/vendors/show`,
  updateVendor: `${BASE_URL}admin/vendors/update`,
  getVendorBalance: `${BASE_URL}admin/vendors/wallet/balance`,
  getVendorTransactionHistory: `${BASE_URL}admin/vendors/wallet/transactions`,

  // ==========================- withdrwal request appr==========================
  getVendorWithrawalRequest: `${BASE_URL}admin/withdrawals`,
  FirstApprovalForVendorWithdrawal: `${BASE_URL}admin/withdrawals/process`,
  SecondApprovalForVendorWithdrawal: `${BASE_URL}admin/withdrawals/process`,

  // =========================== orders ====================================-
  getAllOrders: `${BASE_URL}admin/orders`,
  getOrdersById: `${BASE_URL}admin/orders/show`,
  updateOrders: `${BASE_URL}admin/orders/update`,

  // ======================  Bills Management =============================
  getBillsProduct: `${BASE_URL}admin/bills`,
  getBillsProductsForSwitch: `${BASE_URL}admin/bills/getproducts`,
  changeProductStatus: `${BASE_URL}admin/bills/changeproductstatus`,
  getBillers: `${BASE_URL}admin/bills/getbillers`,
  addBillers: `${BASE_URL}admin/bills/addbiller`,
  editBillers: `${BASE_URL}admin/bills/editbiller`,
  searchBills: `${BASE_URL}admin/bills/search`,
  switch: `${BASE_URL}admin/bills/switch`,
  getSwitchers: `${BASE_URL}admin/bills/getswitchers`,
  addSwitchers: `${BASE_URL}admin/bills/addswitcher`,
  // ========================= flash sales =========================
  getAllFlashsales: `${BASE_URL}admin/flash-sales`,
  createFlashsales: `${BASE_URL}admin/flash-sales/create`,
  updateFlashsales: `${BASE_URL}admin/flash-sales/update`,
  removeFlashsales: `${BASE_URL}admin/flash-sales/delete`,
  // ======================== product property ========================
  getProductProperty: `${BASE_URL}admin/properties`,
  createProductProperty: `${BASE_URL}admin/properties/create`,
  updateProductProperty: `${BASE_URL}admin/properties/update`,
  assignProperty: `${BASE_URL}admin/product/properties/assign`,
  // ==================== admin ticket response ========================
  getAllTicket: `${BASE_URL}admin/tickets`,
  getTicketById: `${BASE_URL}admin/tickets/show`,
  updateTicket: `${BASE_URL}admin/tickets/update`,
  // =============== ticket message ================================
  sendMessageToTicket: `${BASE_URL}admin/message/send`,
  getMessageToTicketById: `${BASE_URL}admin/message/show`,
  //================= Dashboard =====================================
  getDashboard: `${BASE_URL}admin/dashboard`,

  //=======================- app setting for website ===============================--
  getAllAppSettings: `${BASE_URL}admin/app-settings`,
  UpdateAppSettings: `${BASE_URL}admin/app-settings/update`,
  AllSlider: `${BASE_URL}admin/app-settings/sliders`,
  FrontSlider: `${BASE_URL}admin/app-settings/get-sliders`,
  AddSlider: `${BASE_URL}admin/app-settings/slider`,
  deleteSlider: `${BASE_URL}admin/app-settings/slider`,
  //=======================- rider management ===============================--
  getAllRiders: `${BASE_URL}admin/riders`,
  ridersDetails: `${BASE_URL}admin/riders/show`,
  EditRiders: `${BASE_URL}admin/riders/update`,
  //=======================- dashboard management ===============================--
  // getDashboard: `${BASE_URL}admin/dashboard`,
  //=======================- cluster location management ===============================--
  getClusterLocation: `${BASE_URL}admin/distribution-addresses`,
  createClusterLocation: `${BASE_URL}admin/distribution-addresses/create`,
  updateClusterLocation: `${BASE_URL}admin/distribution-addresses/update`,
  deleteClusterLocation: `${BASE_URL}admin/distribution-addresses/delete`,
  // =======================- pending product  ===============================--
  pendingProductStock: `${BASE_URL}admin/product/stocks/pending`,
  updateProductProfit: `${BASE_URL}admin/product/stocks/profit`,
  approveProductStock: `${BASE_URL}admin/product/stocks/approve`,
  // secondApprovalProductStock: `${BASE_URL}admin/product/stocks/approve`,
  // ========================= physical product ===============================
  getAllPhysicalProduct: `${BASE_URL}admin/get-discounts`,
  updateAllPhysicalProduct: `${BASE_URL}admin/update-discount`,
  // ========================= returned orders ===============================
  getReturnedOrdersByCustomer: `${BASE_URL}admin/orders/cancellation`,
  UpdateCustomerReturnOrder: `${BASE_URL}admin/orders/cancellation/update`,
  returnCustomerOrderByAdmin: `${BASE_URL}admin/orders/cancellation/create`,

  // ====================== OPERATIONS =============================
  // branches
  getAllBranchOperations: `${BASE_URL}admin/branch/office`,
  getAllBranchOpeById: `${BASE_URL}admin/branch/office/show`,
  createBranchOpe: `${BASE_URL}admin/branch/office/create`,
  updateBranchOpe: `${BASE_URL}admin/branch/office/update`,
  activateBranchOpe: `${BASE_URL}admin/branch/office/toggle-activation`,
  fundBranchWalletsOpe: `${BASE_URL}admin/branch/office/fund-wallet`,
  getBranchOpeActivity: `${BASE_URL}admin/branch/office/activities`,

  // incentives
  getBranchOpeIncentives: `${BASE_URL}admin/branch/incentives/show`,
  getBranchOpeStatistic: `${BASE_URL}admin/branch/incentives/statistics`,
  BranchOpeCreateIncentives: `${BASE_URL}admin/branch/incentives/create`,
  updateBranchOpeCreateIncentives: `${BASE_URL}admin/branch/incentives/update`,
  deleteBranchOpeCreateIncentives: `${BASE_URL}admin/branch/incentives/delete`,
  pendingBranchOpeCreateIncentives: `${BASE_URL}admin/branch/incentives/pending`,
  processBranchOpeCreateIncentives: `${BASE_URL}admin/branch/incentives/process`,

  // expenses
  getExpenseOpePending: `${BASE_URL}admin/branch/expenses`,
  getExpenseOpeById: `${BASE_URL}admin/branch/expenses/show`,
  ExpenseOpeApproval: `${BASE_URL}admin/branch/expenses/approve`,
  ExpenseOpeBulkApproval: `${BASE_URL}admin/branch/expenses/bulk-approve`,
  RejectExpenseOpe: `${BASE_URL}admin/branch/expenses/reject`,
  PaymentExpenseOpe: `${BASE_URL}admin/branch/expenses/pay`,
  getExpensesOpeStatistic: `${BASE_URL}admin/branch/expenses/statistics`,

  // branch product
  getAllBranchProduct: `${BASE_URL}admin/transactions/view-branch-products`,
  createBranchProduct: `${BASE_URL}admin/transactions/create-branch-products`,
  updateBranchProduct: `${BASE_URL}admin/transactions/update-branch-products`,
  deleteBranchProduct: `${BASE_URL}admin/transactions/delete-branch-products`,
  // branch product category
  getAllBranchProductCategory: `${BASE_URL}admin/transactions/view-product-categories`,
  createBranchProductCategory: `${BASE_URL}admin/transactions/create-product-categories`,
  updateBranchProductCategory: `${BASE_URL}admin/transactions/update-product-categories`,
  deleteBranchProductCategory: `${BASE_URL}admin/transactions/delete-product-categories`,
  // branch product Unit
  getAllBranchProductUnit: `${BASE_URL}admin/transactions/view-product-units`,
  createBranchProductUnit: `${BASE_URL}admin/transactions/create-product-units`,
  updateBranchProductUnit: `${BASE_URL}admin/transactions/update-product-units`,
  deleteBranchProductUnit: `${BASE_URL}admin/transactions/delete-product-units`,
  // branch customer
  getBranchCustomer: `${BASE_URL}admin/transactions/get-customer`,

  // get branch sales
  getBranchSalesHistory: `${BASE_URL}admin/stock/history`,
  // dashboard
  getBranchDashboard: `${BASE_URL}admin/reports/dashboard-analytics`,
  // report
  getTopBranchReport: `${BASE_URL}admin/reports/top-branches`,
  getTopBranchCustomerReport: `${BASE_URL}admin/reports/top-customers`,

  // delivery location price
  getAllDeliveryLocprice: `${BASE_URL}admin/settings/view-price-locations`,
  createDeliveryLocprice: `${BASE_URL}admin/settings/add-price-locations`,
  updateDeliveryLocprice: `${BASE_URL}admin/settings/update-price-location`,
  deleteDeliveryLocprice: `${BASE_URL}admin/settings/delete-price-location`,
  // physical product commission
  getAllPhysicalProductCom: `${BASE_URL}admin/commission/commission-category`,
  createPhysicalProductCom: `${BASE_URL}admin/commission/create`,
  updatePhysicalProductCom: `${BASE_URL}admin/commission/update`,
  deletePhysicalProductCom: `${BASE_URL}admin/commission/delete`,
  assignToUserPhysicalProductCom: `${BASE_URL}admin/commission/assign`,
  // wallet
  getAllWalletHistory: `${BASE_URL}admin/branch/office/wallet-history`,
  getTransactionHistory: `${BASE_URL}admin/branch/office/transactions`,

  // branch purchase and restock
  getAllPurchaseItem: `${BASE_URL}admin/branch/purchases`,
  getPendingPurchaseItem: `${BASE_URL}admin/branch/purchases/pending`,
  approvePurchaseItem: `${BASE_URL}admin/branch/purchases/approve`,
  rejectPurchaseItem: `${BASE_URL}admin/branch/purchases/reject`,
  bulkPurchaseApproval: `${BASE_URL}admin/branch/purchases/bulk-approve`,

  // remitance
  getAllRemittance: `${BASE_URL}admin/branch/remittances`,
  getPendingRemittance: `${BASE_URL}admin/branch/remittances/pending`,
  acceptProcessRemittance: `${BASE_URL}admin/branch/remittances/process`,
  rejectProcessRemittance: `${BASE_URL}admin/branch/remittances/process`,
  DeductedRemittance: `${BASE_URL}admin/branch/remittances/deduct`,
  bulkRemittanceApproval: `${BASE_URL}admin/branch/remittances/bulk-approve`,

  // branch stock monitoring
  branchStockMonitoring: `${BASE_URL}admin/branch/office/monitor`,




};

export default API_URLS;
